// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Box = require("./Atom_Box.bs.js");
var Atom_Row = require("./Atom_Row.bs.js");
var Atom_Cell = require("./Atom_Cell.bs.js");
var Atom_Logo = require("./Atom_Logo.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Text_Ds = require("./Atom_Text_Ds.bs.js");
var Atom_Text_Css = require("./Atom_Text_Css.bs.js");
var Particle_Color = require("../particle/Particle_Color.bs.js");
var Atom_Icon_Internal = require("./icon/Atom_Icon_Internal.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function Atom_Text$ScreenreadersLabel$Internal(Props) {
  var children = Props.children;
  var kindOpt = Props.kind;
  var id = Props.id;
  var accessibility = Props.accessibility;
  var kind = kindOpt !== undefined ? kindOpt : "span";
  var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
        CssJs.position(CssJs.absolute),
        CssJs.width(CssJs.px(1)),
        CssJs.height(CssJs.px(1)),
        CssJs.padding(CssJs.px(0)),
        CssJs.overflow(CssJs.hidden),
        CssJs.unsafe("clip", "rect(0 0 0 0)"),
        CssJs.whiteSpace(CssJs.nowrap),
        CssJs.border(CssJs.px(0), CssJs.solid, CssJs.transparent)
      ]);
  var tmp = {
    children: children,
    kind: {
      TAG: /* Text */13,
      _0: kind
    },
    rules: rules
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  return React.createElement(Atom_Row.make, tmp);
}

var Internal = {
  make: Atom_Text$ScreenreadersLabel$Internal
};

function Atom_Text$ScreenreadersLabel(Props) {
  var children = Props.children;
  var kindOpt = Props.kind;
  var id = Props.id;
  var accessibility = Props.accessibility;
  var kind = kindOpt !== undefined ? kindOpt : "span";
  var tmp = {
    children: children,
    kind: kind
  };
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  return React.createElement(Atom_Text$ScreenreadersLabel$Internal, tmp);
}

function Atom_Text$ScreenreadersLabel$Replay(Props) {
  var label = Props.label;
  return React.createElement(Atom_Text$ScreenreadersLabel$Internal, {
              children: label,
              kind: "h1"
            });
}

var Replay = {
  make: Atom_Text$ScreenreadersLabel$Replay
};

var ScreenreadersLabel = {
  Internal: Internal,
  make: Atom_Text$ScreenreadersLabel,
  Replay: Replay
};

function renderChildrenWithAsset(children, asset, param) {
  if (children !== undefined) {
    var children$1 = Caml_option.valFromOption(children);
    if (asset === undefined) {
      return [
              children$1,
              undefined,
              undefined
            ];
    }
    if (asset.TAG === /* Logo */0) {
      var match = asset._0;
      var logo = match.logo;
      var position = match.position;
      if (typeof position === "number") {
        return [
                React.createElement(React.Fragment, undefined, React.createElement(Atom_Logo.make, {
                          logo: logo
                        }), React.createElement(Atom_Text$ScreenreadersLabel, {
                          children: children$1
                        })),
                undefined,
                Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
              ];
      } else if (position.TAG === /* Left */0) {
        return [
                React.createElement(React.Fragment, undefined, React.createElement(Atom_Cell.make, {
                          kind: /* Span */8,
                          children: React.createElement(Atom_Logo.make, {
                                logo: logo
                              })
                        }), React.createElement(Atom_Cell.make, {
                          kind: /* Span */8,
                          children: children$1
                        })),
                Caml_option.some(position._0),
                Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
              ];
      } else {
        return [
                React.createElement(React.Fragment, undefined, React.createElement(Atom_Cell.make, {
                          kind: /* Span */8,
                          children: children$1
                        }), React.createElement(Atom_Cell.make, {
                          kind: /* Span */8,
                          children: React.createElement(Atom_Logo.make, {
                                logo: logo
                              })
                        })),
                Caml_option.some(position._0),
                Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
              ];
      }
    }
    var match$1 = asset._0;
    var size = match$1.size;
    var icon = match$1.icon;
    var position$1 = match$1.position;
    if (typeof position$1 === "number") {
      return [
              React.createElement(React.Fragment, undefined, React.createElement(Atom_Icon_Internal.make, {
                        icon: icon,
                        size: size
                      }), React.createElement(Atom_Text$ScreenreadersLabel, {
                        children: children$1
                      })),
              undefined,
              Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
            ];
    } else if (position$1.TAG === /* Left */0) {
      return [
              React.createElement(React.Fragment, undefined, React.createElement(Atom_Cell.make, {
                        kind: /* Span */8,
                        children: React.createElement(Atom_Icon_Internal.make, {
                              icon: icon,
                              size: size
                            })
                      }), React.createElement(Atom_Cell.make, {
                        kind: /* Span */8,
                        children: children$1
                      })),
              Caml_option.some(position$1._0),
              Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
            ];
    } else {
      return [
              React.createElement(React.Fragment, undefined, React.createElement(Atom_Cell.make, {
                        kind: /* Span */8,
                        children: children$1
                      }), React.createElement(Atom_Cell.make, {
                        kind: /* Span */8,
                        children: React.createElement(Atom_Icon_Internal.make, {
                              icon: icon,
                              size: size
                            })
                      })),
              Caml_option.some(position$1._0),
              Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
            ];
    }
  }
  if (asset === undefined) {
    return [
            null,
            undefined,
            undefined
          ];
  }
  if (asset.TAG === /* Logo */0) {
    return [
            React.createElement(Atom_Logo.make, {
                  logo: asset._0.logo
                }),
            undefined,
            undefined
          ];
  }
  var match$2 = asset._0;
  return [
          React.createElement(Atom_Icon_Internal.make, {
                icon: match$2.icon,
                size: match$2.size
              }),
          undefined,
          Caml_option.some(Particle_Screen_Constants.alignItemsCenter)
        ];
}

function Atom_Text$Internal(Props) {
  var accessibility = Props.accessibility;
  var autoSize = Props.autoSize;
  var blockSpace = Props.blockSpace;
  var children = Props.children;
  var id = Props.id;
  var identifier = Props.identifier;
  var justifyContent = Props.justifyContent;
  var kindOpt = Props.kind;
  var maxWidth = Props.maxWidth;
  var mediaQueryKind = Props.mediaQueryKind;
  var styleOpt = Props.style;
  var width = Props.width;
  var height = Props.height;
  var textRef = Props.textRef;
  var rules = Props.rules;
  var kind = kindOpt !== undefined ? kindOpt : ({
        TAG: /* Text */13,
        _0: "p"
      });
  var style = styleOpt !== undefined ? styleOpt : Atom_Text_Ds.$$default;
  var view = Atom_Text_Ds.view(style);
  var textRules = Atom_Text_Css.toCss(view);
  var rules$1 = Particle_Screen_Ds.$$Array.concatOrDefault(textRules, rules);
  var match = renderChildrenWithAsset(children, view.asset, undefined);
  var tmp = {
    children: match[0],
    direction: Particle_Screen_Constants.flexDirectionRow,
    display: view.display,
    kind: kind,
    rules: rules$1
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  var tmp$1 = match[2];
  if (tmp$1 !== undefined) {
    tmp.alignItems = Caml_option.valFromOption(tmp$1);
  }
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (identifier !== undefined) {
    tmp.identifier = identifier;
  }
  if (justifyContent !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(justifyContent);
  }
  if (maxWidth !== undefined) {
    tmp.maxWidth = Caml_option.valFromOption(maxWidth);
  }
  if (mediaQueryKind !== undefined) {
    tmp.mediaQueryKind = Caml_option.valFromOption(mediaQueryKind);
  }
  if (blockSpace !== undefined) {
    tmp.spacer = Caml_option.valFromOption(blockSpace);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  var tmp$2 = match[1];
  if (tmp$2 !== undefined) {
    tmp.innerSpace = Caml_option.valFromOption(tmp$2);
  }
  if (textRef !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Box.make, tmp);
}

var Internal$1 = {
  renderChildrenWithAsset: renderChildrenWithAsset,
  make: Atom_Text$Internal
};

function Atom_Text$Unsafe(Props) {
  var accessibility = Props.accessibility;
  var kindOpt = Props.kind;
  var id = Props.id;
  var children = Props.children;
  var rules = Props.rules;
  var kind = kindOpt !== undefined ? kindOpt : "span";
  var tmp = {
    children: Belt_Option.getWithDefault(children, null),
    kind: {
      TAG: /* Text */13,
      _0: kind
    },
    rules: rules
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var Unsafe = {
  make: Atom_Text$Unsafe
};

function Atom_Text$Responsive$ChildrenResponsive(Props) {
  var label = Props.label;
  var rules = Props.rules;
  var style = Props.style;
  if (label !== undefined) {
    return React.createElement(Atom_Text$Internal, {
                children: label,
                mediaQueryKind: /* MinMaxWidth */1,
                style: style,
                rules: rules,
                key: Uuid.v4()
              });
  } else {
    return null;
  }
}

var ChildrenResponsive = {
  make: Atom_Text$Responsive$ChildrenResponsive
};

function getDisplayRules(elements, currentElement) {
  var getDisplayValue = function (value1, value2) {
    if (value1 !== undefined) {
      if (value2 !== undefined) {
        if (value1 === value2) {
          return [CssJs.display("flex")];
        } else {
          return [CssJs.display("none")];
        }
      } else {
        return [CssJs.display("none")];
      }
    } else {
      return [CssJs.display("none")];
    }
  };
  return Particle_Screen_Ds.zipWith(getDisplayValue, elements, currentElement);
}

function Atom_Text$Responsive$Children(Props) {
  var style = Props.style;
  var labels = Props.labels;
  var label = Particle_Screen_Ds.view(labels);
  if (label.TAG === /* AllSize */0) {
    return React.createElement(Atom_Text$Internal, {
                children: Belt_Option.mapWithDefault(label._0, null, (function (prim) {
                        return prim;
                      })),
                style: style
              });
  }
  var defaultLabel = label._0;
  var elements = Belt_Array.map(label._1, (function (localSize) {
          var localString = Particle_Screen_Ds.extractValue(localSize);
          var dsScreenLocalSize = Particle_Screen_Ds.makeForScreenSize(undefined, localSize);
          var rules = getDisplayRules(labels, dsScreenLocalSize);
          return React.createElement(Atom_Text$Responsive$ChildrenResponsive, {
                      label: localString,
                      rules: rules,
                      style: style,
                      key: Particle_Screen_Ds.screenSizeToString(localSize)
                    });
        }));
  var dsScreenLocalSize = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, defaultLabel);
  var rules = getDisplayRules(labels, dsScreenLocalSize);
  var defaultBox = React.createElement(Atom_Text$Responsive$ChildrenResponsive, {
        label: defaultLabel,
        rules: rules,
        style: style,
        key: "default"
      });
  return Util_Array.prepend(elements, defaultBox);
}

var Children = {
  make: Atom_Text$Responsive$Children
};

function Atom_Text$Responsive(Props) {
  var autoSize = Props.autoSize;
  var accessibility = Props.accessibility;
  var styleOpt = Props.style;
  var kindOpt = Props.kind;
  var width = Props.width;
  var id = Props.id;
  var labels = Props.labels;
  var textRef = Props.textRef;
  var style = styleOpt !== undefined ? styleOpt : Atom_Text_Ds.$$default;
  var kind = kindOpt !== undefined ? kindOpt : "div";
  var view = Atom_Text_Ds.view(style);
  var rules = Atom_Text_Css.toCss(view);
  var tmp = {
    children: React.createElement(Atom_Text$Responsive$Children, {
          style: style,
          labels: labels
        }),
    direction: Particle_Screen_Constants.flexDirectionRow,
    kind: {
      TAG: /* Text */13,
      _0: kind
    },
    rules: rules
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (textRef !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Box.make, tmp);
}

var Responsive = {
  ChildrenResponsive: ChildrenResponsive,
  getDisplayRules: getDisplayRules,
  Children: Children,
  make: Atom_Text$Responsive
};

function Atom_Text(Props) {
  var accessibility = Props.accessibility;
  var autoSize = Props.autoSize;
  var blockSpace = Props.blockSpace;
  var children = Props.children;
  var id = Props.id;
  var identifier = Props.identifier;
  var justifyContent = Props.justifyContent;
  var kind = Props.kind;
  var maxWidth = Props.maxWidth;
  var style = Props.style;
  var width = Props.width;
  var textRef = Props.textRef;
  var tmp = {
    kind: kind !== undefined ? ({
          TAG: /* Text */13,
          _0: kind
        }) : ({
          TAG: /* Text */13,
          _0: "p"
        })
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (blockSpace !== undefined) {
    tmp.blockSpace = Caml_option.valFromOption(blockSpace);
  }
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (identifier !== undefined) {
    tmp.identifier = Caml_option.valFromOption(identifier);
  }
  if (justifyContent !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(justifyContent);
  }
  if (maxWidth !== undefined) {
    tmp.maxWidth = Caml_option.valFromOption(maxWidth);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

function Atom_Text$Mona$Internal(Props) {
  var height = Props.height;
  var variantOpt = Props.variant;
  var tagOpt = Props.tag;
  var children = Props.children;
  var textRef = Props.textRef;
  var variant = variantOpt !== undefined ? variantOpt : "default";
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var dsVariant = variant === "emailDisplaying" ? Atom_Text_Ds.Mona.makeEmailDisplaying : (
      variant === "info" ? Atom_Text_Ds.Mona.makeInfo : (
          variant === "description" ? Atom_Text_Ds.Mona.makeDescription : (
              variant === "subtitle" ? Atom_Text_Ds.Mona.makeSubtitle : (
                  variant === "error" ? Atom_Text_Ds.makeFeedback("Error") : (
                      variant === "eventInfo" ? Atom_Text_Ds.Mona.makeEventInfo : (
                          variant === "footer" ? Atom_Text_Ds.Mona.makeFooter : (
                              variant === "title" ? Atom_Text_Ds.Mona.makeTitle : (
                                  variant === "default" ? Atom_Text_Ds.Mona.makeDefault : (
                                      variant === "success" ? Atom_Text_Ds.makeFeedback("Success") : Atom_Text_Ds.makeSuccess
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  var tmp = {
    children: children,
    kind: {
      TAG: /* Text */13,
      _0: tag
    },
    style: dsVariant
  };
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var Internal$2 = {
  make: Atom_Text$Mona$Internal
};

function Atom_Text$Mona(Props) {
  var variantOpt = Props.variant;
  var tagOpt = Props.tag;
  var children = Props.children;
  var textRef = Props.textRef;
  var variant = variantOpt !== undefined ? variantOpt : "default";
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var tmp = {
    variant: variant,
    tag: tag,
    children: children
  };
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Mona$Internal, tmp);
}

var Mona = {
  Internal: Internal$2,
  make: Atom_Text$Mona
};

function Atom_Text$DangerouslySetInnerHTML(Props) {
  var styleOpt = Props.style;
  var id = Props.id;
  var dangerouslySetInnerHTML = Props.dangerouslySetInnerHTML;
  var textRef = Props.textRef;
  var style = styleOpt !== undefined ? styleOpt : Atom_Text_Ds.$$default;
  var tmp = {
    kind: {
      TAG: /* DangerouslySetInnerHTML */3,
      _0: dangerouslySetInnerHTML
    },
    style: style
  };
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var DangerouslySetInnerHTML = {
  make: Atom_Text$DangerouslySetInnerHTML
};

function makeDsVariant(variant) {
  if (variant === "date") {
    return Atom_Text_Ds.Papa.makeDate;
  } else if (variant === "title") {
    return Atom_Text_Ds.Papa.makeTitle;
  } else {
    return Atom_Text_Ds.Papa.makeDefault;
  }
}

function Atom_Text$Papa(Props) {
  var variantOpt = Props.variant;
  var tagOpt = Props.tag;
  var children = Props.children;
  var textRef = Props.textRef;
  var variant = variantOpt !== undefined ? variantOpt : "default";
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var dsVariant = makeDsVariant(variant);
  var tmp = {
    children: children,
    kind: {
      TAG: /* Text */13,
      _0: tag
    },
    style: dsVariant
  };
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var Papa = {
  makeDsVariant: makeDsVariant,
  make: Atom_Text$Papa
};

function makeDsVariant$1(variant, theme) {
  switch (variant) {
    case /* HeroTitle */0 :
        return Atom_Text_Ds.AndroidReleases.makeHeroTitle;
    case /* HeroSubTitle */1 :
        return Atom_Text_Ds.AndroidReleases.makeHeroSubTitle;
    case /* HeroTutorial */2 :
        return Atom_Text_Ds.AndroidReleases.makeHeroTutorial;
    case /* PageTitle */3 :
        return Atom_Text_Ds.AndroidReleases.makePageTitle;
    case /* ListTitle */4 :
        return Atom_Text_Ds.AndroidReleases.makeListTitle;
    case /* ReleaseTitle */5 :
        return Atom_Text_Ds.AndroidReleases.makeReleaseTitle(theme);
    
  }
}

function Atom_Text$AndroidReleases(Props) {
  var variant = Props.variant;
  var tagOpt = Props.tag;
  var themeOpt = Props.theme;
  var children = Props.children;
  var textRef = Props.textRef;
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var theme = themeOpt !== undefined ? themeOpt : Particle_Color.Var.$$default;
  var dsVariant = makeDsVariant$1(variant, theme);
  var tmp = {
    children: children,
    kind: {
      TAG: /* Text */13,
      _0: tag
    },
    style: dsVariant
  };
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var AndroidReleases = {
  makeDsVariant: makeDsVariant$1,
  make: Atom_Text$AndroidReleases
};

function Atom_Text$Player(Props) {
  var variantOpt = Props.variant;
  var tagOpt = Props.tag;
  var children = Props.children;
  var textRef = Props.textRef;
  var variant = variantOpt !== undefined ? variantOpt : "default";
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var dsVariant = variant === "programTitle" ? Atom_Text_Ds.Player.makeProgramTitle : (
      variant === "subtitle" ? Atom_Text_Ds.Player.makeSubtitle : (
          variant === "hoverChapter" ? Atom_Text_Ds.Player.makeHoverChapter : (
              variant === "title" ? Atom_Text_Ds.Player.makeTitle : (
                  variant === "hoverNextChapter" ? Atom_Text_Ds.Player.makeHoverNextChapter : (
                      variant === "message" ? Atom_Text_Ds.Player.makeMessage : (
                          variant === "default" ? Atom_Text_Ds.Player.makeDefault : Atom_Text_Ds.Player.makeDate
                        )
                    )
                )
            )
        )
    );
  var tmp = {
    children: children,
    kind: {
      TAG: /* Text */13,
      _0: tag
    },
    style: dsVariant
  };
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var Player = {
  make: Atom_Text$Player
};

function Atom_Text$Presse$Internal(Props) {
  var height = Props.height;
  var variantOpt = Props.variant;
  var tagOpt = Props.tag;
  var children = Props.children;
  var textRef = Props.textRef;
  var variant = variantOpt !== undefined ? variantOpt : "default";
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var dsVariant = variant === "subtitle" ? Atom_Text_Ds.Presse.makeSubtitle : (
      variant === "error" ? Atom_Text_Ds.makeFeedback("Error") : (
          variant === "title" ? Atom_Text_Ds.Presse.makeTitle : (
              variant === "default" ? Atom_Text_Ds.Presse.makeDefault : (
                  variant === "success" ? Atom_Text_Ds.makeFeedback("Success") : Atom_Text_Ds.Presse.makeInfo
                )
            )
        )
    );
  var tmp = {
    children: children,
    kind: {
      TAG: /* Text */13,
      _0: tag
    },
    style: dsVariant
  };
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Internal, tmp);
}

var Internal$3 = {
  make: Atom_Text$Presse$Internal
};

function Atom_Text$Presse(Props) {
  var variantOpt = Props.variant;
  var tagOpt = Props.tag;
  var children = Props.children;
  var textRef = Props.textRef;
  var variant = variantOpt !== undefined ? variantOpt : "default";
  var tag = tagOpt !== undefined ? tagOpt : "p";
  var tmp = {
    variant: variant,
    tag: tag,
    children: children
  };
  if (textRef !== undefined) {
    tmp.textRef = Caml_option.valFromOption(textRef);
  }
  return React.createElement(Atom_Text$Presse$Internal, tmp);
}

var Presse = {
  Internal: Internal$3,
  make: Atom_Text$Presse
};

var make = Atom_Text;

exports.ScreenreadersLabel = ScreenreadersLabel;
exports.Internal = Internal$1;
exports.Unsafe = Unsafe;
exports.Responsive = Responsive;
exports.make = make;
exports.Mona = Mona;
exports.DangerouslySetInnerHTML = DangerouslySetInnerHTML;
exports.Papa = Papa;
exports.AndroidReleases = AndroidReleases;
exports.Player = Player;
exports.Presse = Presse;
/* uuid Not a pure module */
